import { useMemo } from "react";
import { useFirestoreConnect } from "react-redux-firebase";
/**
 *
 * @param {String} collection - collection in Firebase
 * @param {String} listener - param to listen for changes
 * @return {void}
 */
const useFirestoreListener = (firebaseQuery, listeners) => {
  const query = useMemo(() => {
    const isListenersReady = listeners && listeners.every((l) => l);
    if (isListenersReady) {
      return firebaseQuery;
    }
  }, [firebaseQuery, listeners]);
  useFirestoreConnect(query);
};
// const useFirestoreListener = ({ collection, where, condition, listener }) => {
//   const query = useMemo(() => {
//     if (listener) {
//       return {
//         collection,
//         where: [where, condition, listener],
//       };
//     }
//   }, [collection, condition, listener, where]);
//   useFirestoreConnect(query);
// };

export default useFirestoreListener;
